/*
Loons Lab Sub title component
Developed By Roshan
Loons Lab
*/
import React, { Component } from "react";
import {Typography } from '@material-ui/core'
import { themeColors } from 'app/components/MatxTheme/themeColors'
import { MatxLayoutSettings } from 'app/components/MatxLayout/settings'
import { any } from "prop-types";


class SubTitle extends Component {
    static propTypes = {
        title: any
    };

    static defaultProps = {
        title: null
    };



    render() {
        const {
            title
        } = this.props;
        let activeTheme = MatxLayoutSettings.activeTheme

        return (
            <Typography className="font-semibold text-13" style={{ lineHeight: '1',color: themeColors[activeTheme].palette.subTitleTextColor }}>{title}</Typography>

        );
    }
}

export default SubTitle;